const { appendFilter } = require('../../../queries');
const addScheduledTransactionsQueries = require('../../../queries/configs/ScheduledTransactions');

module.exports = addScheduledTransactionsQueries(function ({ payerId, baseUrl }) {
  return ({
    baseUrl: `${baseUrl}/${payerId}/schedtrans`,
    queriesFilter: appendFilter('payerId', payerId),
  })
});
